import { render, staticRenderFns } from "./CriarConfiguracaoUpdateEnquetes.vue?vue&type=template&id=cc073a26&scoped=true"
import script from "./CriarConfiguracaoUpdateEnquetes.vue?vue&type=script&lang=js"
export * from "./CriarConfiguracaoUpdateEnquetes.vue?vue&type=script&lang=js"
import style0 from "./CriarConfiguracaoUpdateEnquetes.vue?vue&type=style&index=0&id=cc073a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc073a26",
  null
  
)

export default component.exports